type Props = {
  size?: number;
  className?: string;
};

/** Inline rather than a .webp like the newer coins: the XRP mark is two paths
 *  on a disc, so it costs less as SVG than as an image and stays sharp at any
 *  size — the same call BtcIcon makes. */
export function XrpIcon({ size = 44, className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      aria-label="XRP"
    >
      <g fill="none">
        <circle cx="16" cy="16" r="16" fill="#23292F" />
        <path
          fill="#FFF"
          d="M23.07 8h2.89l-6.015 5.957a5.621 5.621 0 01-7.89 0L6.035 8H8.93l4.57 4.523a3.556 3.556 0 004.996 0L23.07 8zM8.895 24.563H6l6.055-5.993a5.621 5.621 0 017.89 0L26 24.562h-2.895L18.5 20a3.556 3.556 0 00-4.996 0l-4.61 4.563z"
        />
      </g>
    </svg>
  );
}
